export default __webpack_public_path__ + "static/media/demo_02.35227398.png";